<template>
	<div>
	  <div class="text-right">
		{{
		  locationCount > 0
			? `Registros encontrados: ${locationCount}`
			: 'No se han encontrado registros'
		}}
	  </div>
	  <b-table striped hover :items="locations" :fields="tableHeader">
		<template #cell(status)="data">
		  {{ data.item && data.item.state ? 'Activa' : 'Inactiva' }}
		</template>
		<template #cell(dates)="data">
		  <p class="m-0">
			Inicio Vigencia: <b>{{ data.item.effectiveStartDate }}</b>
		  </p>
		  <p class="m-0">
			Término Vigencia: <b>{{ data.item.effectiveEndDate }}</b>
		  </p>
		</template>
		<template #cell(action)="data">
		  <b-dropdown no-flip text="Acción" class="mb-2 mr-2" variant="primary">
			<ul class="nav flex-column">
			  <li class="nav-item">
				<a
				  href="javascript:void(0);"
				  class="nav-link"
				  @click="openModal(data.item, 'manage-schedule')"
				  >Gestionar Horario</a
				>
			  </li>
			  <!-- <li class="nav-item">
				<a
				  href="javascript:void(0);"
				  class="nav-link"
				  @click="openModal(data.item, 'update-location-data')"
				  >Actualizar datos</a
				>
			  </li> -->
			  <!-- <li class="nav-item">
				<a
				  href="javascript:void(0);"
				  class="nav-link"
				  @click="openModal(data.item, 'assignLead')"
				  >{{ !data.item.user_id ? 'Asignar' : 'Reasignar' }}</a
				>
			  </li> -->
			</ul>
		  </b-dropdown>
		</template>
	  </b-table>
		  <b-row>
		<b-col
		  cols="12"
		  md="6"
		  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
		>
		  <label class="ml-1">Entries</label>
		  <v-select
			v-model="pageQuantity"
			:options="perPageOptions"
			:clearable="false"
			class="per-page-selector d-inline-block ml-50 mr-1"
			@input="manageGetLocations"
			:appendToBody="true"
			:calculate-position="withPopper"
		  />
		</b-col>
		<b-col
		  cols="12"
		  md="6"
		  class="d-flex align-items-center justify-content-end"
		>
		  <b-pagination
			class="pr-2 pt-1"
			align="right"
			v-if="locations"
			v-model="getPage"
			:total-rows="locationCount"
			:per-page="pageQuantity"
		  />
		</b-col>
	  </b-row>
	</div>
  </template>
  
  <script>
  import { mapActions, mapState, mapMutations } from 'vuex'
  import {
	BTable,
	BButton,
	BDropdown,
	BRow,
	BCol,
	BPagination,
  } from 'bootstrap-vue'
  import swal from 'sweetalert2'
  import moment from 'moment'
  import vSelect from 'vue-select'
  import withPopper from '@/libs/vue-select'
  import { getUserData } from '@/auth/utils'
  
  export default {
	components: {
	  BTable,
	  BButton,
	  BDropdown,
	  BRow,
	  BCol,
	  BPagination,
	  vSelect,
	},
	props: ['tableHeader'],
	data() {
	  return {
		userData: getUserData(),
		perPageOptions: [5, 10, 25, 50, 100],
		withPopper,
	  }
	},
	watch: {
	  getPage: {
		handler(value) {
		  this.setOffset(this.pageQuantity * (value - 1))
		  this.manageGetLocations()
		},
	  },
	},
	computed: {
	  ...mapState('locations', ['locations', 'locationCount']),
	  ...mapState('tableFilters', ['selectedTypeFilter']),
	  getPage: {
		get() {
		  return this.$store.state.tableFilters.actualPage
		},
		set(value) {
		  this.setActualPage(value)
		},
	  },
	  pageQuantity: {
		get() {
		  return this.$store.state.tableFilters.pageQuantity
		},
		set(value) {
		  this.setPageQuantity(value)
		},
	  },
	},
	methods: {
	  manageGetLocations() {
		this.getLocations({ user_id: this.userData.id })
		  .then((response) => {})
		  .catch((errors) => {})
	  },
	  ...mapActions('locations', ['getLocations']),
	  ...mapMutations('tableFilters', [
		'setOffset',
		'setActualPage',
		'setPageQuantity',
	  ]),
	  getDateFormat(unix) {
		//return `${new Date(unix * 1000).toLocaleDateString("en-US")} ${new Date(unix * 1000).toLocaleTimeString("en-US")}`
		return moment.unix(unix).format('YYYY-MM-DD, h:mm:ss A')
	  },
	  async openModal(lead, type) {
		await this.setSelectedLocation(lead)
		this.toggleModal({ value: true, type })
	  },
	  ...mapMutations('locations', ['toggleModal', 'setSelectedLocation']),
	  getContactLink(lead) {
		return `https://admin2.vendetuauto.com/crm/contacts/detail/${lead.contact?.cms_contact_id}`
	  },
	  getLeadH(id) {
		// console.log(id)
		this.getLeadHistory(id)
	  },
	},
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
  
  <style lang="scss" scoped>
  .card-body {
	padding: 0px !important;
  }
  .per-page-selector {
	width: 90px;
  }
  
  .invoice-filter-select {
	min-width: 190px;
  
	::v-deep .vs__selected-options {
	  flex-wrap: nowrap;
	}
  
	::v-deep .vs__selected {
	  width: 100px;
	}
  }
  </style>
  